function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_2743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9347 13.6562C13.5834 13.7353 13.2184 13.731 12.8691 13.6436L5.59533 11.8252L4.27533 17.5945C4.25354 17.6894 4.2562 17.7882 4.28305 17.8818C4.30991 17.9754 4.36008 18.0607 4.42887 18.1296C6.13616 19.8357 10.197 20.4453 13.4282 20.4453C16.6583 20.4453 20.7192 19.8208 22.4276 18.1124C22.4962 18.0404 22.546 17.9528 22.5728 17.8571C22.5995 17.7614 22.6024 17.6606 22.5812 17.5635L21.299 11.9845L13.9347 13.6562Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.1859 7.42192L13.5818 5.70317C13.4741 5.68871 13.3649 5.68948 13.2575 5.70546L1.79916 7.42421C1.53717 7.46381 1.29694 7.59281 1.11922 7.78933C0.94149 7.98586 0.837207 8.2378 0.824053 8.50244C0.798845 9.04786 1.16093 9.53598 1.69145 9.6689L13.1498 12.5335C13.3243 12.5755 13.5059 12.5778 13.6814 12.5404L26.2856 9.67577C26.5476 9.61655 26.7803 9.46693 26.9429 9.2532C27.1055 9.03946 27.1876 8.77527 27.1748 8.50702C27.1635 8.23886 27.0583 7.98322 26.8775 7.78484C26.6967 7.58646 26.4519 7.45799 26.1859 7.42192ZM25.4583 10.8491C25.3064 10.8491 25.1607 10.9095 25.0532 11.0169C24.9458 11.1244 24.8854 11.2701 24.8854 11.422V18.297C24.8854 18.6121 25.1432 18.8699 25.4583 18.8699C25.7734 18.8699 26.0312 18.6121 26.0312 18.297V11.422C26.0312 11.2701 25.9709 11.1244 25.8634 11.0169C25.756 10.9095 25.6103 10.8491 25.4583 10.8491ZM25.4583 20.0158C25.1432 20.0158 24.8854 20.2736 24.8854 20.5887V21.7345C24.8854 22.0496 25.1432 22.3074 25.4583 22.3074C25.7734 22.3074 26.0312 22.0496 26.0312 21.7345V20.5887C26.0312 20.2736 25.7734 20.0158 25.4583 20.0158Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_2743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyCap);
export default __webpack_public_path__ + "static/media/study_cap.4289f626dd15acb60a1decb91bdc7546.svg";
export { ForwardRef as ReactComponent };